import { render, staticRenderFns } from "./BigNumber.vue?vue&type=template&id=e408f462&scoped=true&"
import script from "./BigNumber.vue?vue&type=script&lang=js&"
export * from "./BigNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e408f462",
  null
  
)

export default component.exports